<template>
  <div class="per-use-fee">
    <div class="header_padding">
      <el-form :inline="true" class="search-form">
        <el-form-item label="老人姓名">
          <el-input v-model="searchForm.oldName" placeholder="请输入老人姓名" clearable size="small" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button type="success" size="small" @click="openAdd">录入收费</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border stripe style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="60" />
      <el-table-column prop="oldName" label="老人姓名" width="120" />
      <el-table-column prop="feeTypeName" label="费用类型" width="150" />
      <el-table-column prop="feeItemName" label="费用项目" width="150" />
      <el-table-column prop="amount" label="金额(元)" width="120">
        <template slot-scope="scope">
          {{ (scope.row.amount / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="serviceDate" label="服务日期" width="140" />
      <el-table-column prop="statusText" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
            {{ scope.row.status === 1 ? '有效' : '已取消' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" />
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 1"
            type="text"
            size="small"
            @click="handleCancel(scope.row)"
          >取消</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handlePageChange"
      :current-page="pageNum"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      style="margin-top: 15px; text-align: right"
    />

    <!-- 录入弹窗 -->
    <el-dialog title="录入按次收费" :visible.sync="addDialogVisible" width="500px">
      <el-form :model="addForm" label-width="100px">
        <el-form-item label="老人">
          <el-select v-model="addForm.oldId" filterable placeholder="选择老人" style="width: 100%">
            <el-option
              v-for="item in oldmanList"
              :key="item.oldmanId"
              :label="item.oldmanName + (item.bedNo ? '(' + item.bedNo + ')' : '')"
              :value="item.oldmanId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="费用类型">
          <el-select v-model="addForm.feeTypeId" placeholder="选择类型" style="width: 100%">
            <el-option label="护理服务费" :value="1" />
            <el-option label="特殊服务费" :value="2" />
            <el-option label="代购费" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="金额(元)">
          <el-input-number v-model="addForm.amountYuan" :min="0.01" :precision="2" :step="1" style="width: 100%" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" type="textarea" :rows="2" placeholder="备注说明" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="submitAdd">确定</el-button>
      </span>
    </el-dialog>

    <!-- 取消弹窗 -->
    <el-dialog title="取消收费" :visible.sync="cancelDialogVisible" width="400px">
      <el-form :model="cancelForm" label-width="100px">
        <el-form-item label="取消原因">
          <el-input v-model="cancelForm.cancelReason" type="textarea" :rows="2" placeholder="请填写取消原因" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="cancelDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCancel">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PerUseFee",
  data() {
    return {
      searchForm: { oldName: "" },
      tableData: [],
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      addDialogVisible: false,
      addLoading: false,
      addForm: { oldId: null, feeTypeId: null, amountYuan: 0, remark: "" },
      cancelDialogVisible: false,
      cancelForm: { id: null, cancelReason: "" },
      oldmanList: [],
    };
  },
  mounted() {
    this.queryList();
    this.loadOldmanList();
  },
  methods: {
    queryList() {
      this.loading = true;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        oldName: this.searchForm.oldName,
      };
      this.$postJson("fmc/perUseFee/queryListWithPage", params).then(
        (res) => {
          let data = res.result || res;
          this.tableData = data.list || [];
          this.total = Number(data.total || 0);
          this.loading = false;
        },
        () => { this.loading = false; }
      );
    },
    search() {
      this.pageNum = 1;
      this.queryList();
    },
    handlePageChange(val) {
      this.pageNum = val;
      this.queryList();
    },
    loadOldmanList() {
      this.$postJson("fmc/revise/queryOldmanList", { pageNum: 1, pageSize: 999 }).then((res) => {
        let data = res.result || res;
        this.oldmanList = data.list || data || [];
      });
    },
    openAdd() {
      this.addForm = { oldId: null, feeTypeId: null, amountYuan: 0, remark: "" };
      this.addDialogVisible = true;
    },
    submitAdd() {
      if (!this.addForm.oldId) {
        this.$message.warning("请选择老人");
        return;
      }
      if (!this.addForm.amountYuan || this.addForm.amountYuan <= 0) {
        this.$message.warning("请输入金额");
        return;
      }
      this.addLoading = true;
      let params = {
        oldId: this.addForm.oldId,
        feeTypeId: this.addForm.feeTypeId,
        amount: Math.round(this.addForm.amountYuan * 100),
        remark: this.addForm.remark,
      };
      this.$postJson("fmc/perUseFee/add", params).then(
        () => {
          this.$message.success("录入成功");
          this.addDialogVisible = false;
          this.addLoading = false;
          this.queryList();
        },
        (err) => {
          this.$message.error(err.message || "录入失败");
          this.addLoading = false;
        }
      );
    },
    handleCancel(row) {
      this.cancelForm = { id: row.id, cancelReason: "" };
      this.cancelDialogVisible = true;
    },
    submitCancel() {
      this.$postJson("fmc/perUseFee/cancel", this.cancelForm).then(
        () => {
          this.$message.success("取消成功");
          this.cancelDialogVisible = false;
          this.queryList();
        },
        (err) => { this.$message.error(err.message || "取消失败"); }
      );
    },
  },
};
</script>

<style scoped>
.per-use-fee {
  padding: 15px;
}
.header_padding {
  margin-bottom: 15px;
}
</style>
